
export interface GameEntries {
    gameId:number,
    name:string,
    smallSort:number,
    bigSort:number,
    preVipLevel:number,
    openVipLevel:number,
    url:number,
    skinId:number,
    waveLabel:number,
    type:number,

    index?:number,
    isLocking?:boolean,

    defaultDirection:number,//1横。 2竖
    canDirection:number[],
}

export const homeData:GameEntries[] = [
    {"gameId":1, "name":"ele_base_001", "smallSort":13, "bigSort":0, "preVipLevel":2, "openVipLevel":3, "url":3, "skinId":101, "waveLabel":1, "type":2, "defaultDirection":1, "canDirection":[1]},
    {"gameId":2, "name":"min_base_001", "smallSort":2, "bigSort":0, "preVipLevel":1, "openVipLevel":2, "url":2, "skinId":203, "waveLabel":1, "type":1, "defaultDirection":1, "canDirection":[1]},
    {"gameId":3, "name":"ban_base_001", "smallSort":1, "bigSort":0, "preVipLevel":0, "openVipLevel":0, "url":0, "skinId":306, "waveLabel":1, "type":1, "defaultDirection":2, "canDirection":[1,2]},
    {"gameId":4, "name":"min_skin_001", "smallSort":4, "bigSort":0, "preVipLevel":0, "openVipLevel":0, "url":0, "skinId":204, "waveLabel":2, "type":1, "defaultDirection":1, "canDirection":[1]},
    // {"gameId":5, "name":"ele_skin_001", "bigSort":0, "skinId":102, "waveLabel":2, "type":2, "defaultDirection":1, "canDirection":[1]},
    {"gameId":6, "name":"ban_skin_001", "smallSort":12, "bigSort":0, "preVipLevel":0, "openVipLevel":2, "url":2, "skinId":307, "waveLabel":2, "type":2, "defaultDirection":1, "canDirection":[1]},
    {"gameId":7, "name":"pig_base_001", "smallSort":3, "bigSort":0, "preVipLevel":0, "openVipLevel":0, "url":0, "skinId":508, "waveLabel":1, "type":1, "defaultDirection":1, "canDirection":[1]},
    {"gameId":8, "name":"pig_skin_001", "smallSort":10, "bigSort":0, "preVipLevel":0, "openVipLevel":1, "url":1, "skinId":509, "waveLabel":2, "type":2, "defaultDirection":1, "canDirection":[1]},
    {"gameId":9, "name":"tre_base_001", "smallSort":7, "bigSort":0, "preVipLevel":0, "openVipLevel":0, "url":0, "skinId":610, "waveLabel":1, "type":2, "defaultDirection":1, "canDirection":[1]},
    {"gameId":10, "name":"min_skin_002", "smallSort":9, "bigSort":0, "preVipLevel":0, "openVipLevel":1, "url":1, "skinId":205, "waveLabel":2, "type":2, "defaultDirection":1, "canDirection":[1]},
    {"gameId":11, "name":"tre_skin_001", "smallSort":8, "bigSort":0, "preVipLevel":0, "openVipLevel":1, "url":1, "skinId":611, "waveLabel":2, "type":2, "defaultDirection":1, "canDirection":[1]},
    {"gameId":12, "name":"tre_skin_002", "smallSort":11, "bigSort":0, "preVipLevel":0, "openVipLevel":2, "url":2, "skinId":612, "waveLabel":2, "type":2, "defaultDirection":1, "canDirection":[1]},
    {"gameId":15, "name":"pig_skin_002", "smallSort":14, "bigSort":0, "preVipLevel":1, "openVipLevel":3, "url":3, "skinId":513, "waveLabel":2, "type":2, "defaultDirection":1, "canDirection":[1]},
    {"gameId":16, "name":"ban_skin_002", "smallSort":5, "bigSort":0, "preVipLevel":1, "openVipLevel":3, "url":3, "skinId":308, "waveLabel":2, "type":1, "defaultDirection":1, "canDirection":[1]},
    {"gameId":19, "name":"pig_skin_003", "smallSort":15, "bigSort":0, "preVipLevel":2, "openVipLevel":4, "url":4, "skinId":516, "waveLabel":2, "type":2, "defaultDirection":1, "canDirection":[1]},
    {"gameId":20, "name":"tre_skin_003", "smallSort":6, "bigSort":0, "preVipLevel":2, "openVipLevel":4, "url":4, "skinId":617, "waveLabel":1, "type":1, "defaultDirection":1, "canDirection":[1]}
]

export function getGameItemDataId(id:number) {
    for (let i = 0; i < homeData.length; i++) {
        const item = homeData[i];
        if (item.gameId == id) {

            return item;
        }
    }
    return null;
}

